import { Flex } from '@frontend/components';

export const GenericFallbackComponent = () => {
  return (
    <Flex alignItems="center" justifyContent="center">
      An error occurred. Try refreshing the page.
    </Flex>
  );
};
